var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-uploader',{attrs:{"after-read":_vm.afterRead,"capture":"user"},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }